import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { IoIosArrowForward } from "react-icons/io";
import "./mobile..css"

const MobileProfile = () => {
    const navigate = useNavigate();

    useEffect(() => {
      const handleResize = () => {
          if (window.innerWidth > 897) {
              navigate("/");
          }
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, [navigate]);
  
    return ( 
        <div className="mobile-profile-switch">
            <div className="switch">
        <h2>Profile</h2>
        <div
          className="per-info"
          onClick={() => navigate("/charterer-dashboard/updatecustomerprofile")}
        >
          <div>
          <h3>Personal Info</h3>
          <p>Manage personal details</p>
          </div>
          <IoIosArrowForward />
        </div>
        <div className="document" onClick={() => navigate("/charterer-dashboard/typeofupdate")}>
         <div>
         <h3>Documents</h3>
         <p>Update License and other documents</p>
         </div>
          <IoIosArrowForward />
        </div>        
        <div
          className="change-pass"
          onClick={() => navigate("/charterer-dashboard/updatecustomerpass")}
        >
         <div>
         <h3>Password</h3>
         <p>Change and manage password</p>
         </div>
          <IoIosArrowForward />
        </div>
      </div>
        </div>
     );
}
 
export default MobileProfile;